import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="logo-text">Store</div>
            <p>Quality products, fair prices, delivered fast across Pakistan.</p>
          </div>

          <div className="footer-col">
            <h5>Shop</h5>
            <ul>
              <li><Link to="/products">All Products</Link></li>
              <li><Link to="/new-arrivals">New Arrivals</Link></li>
              <li><Link to="/deals">Deals</Link></li>
              <li><Link to="/most-selling">Most Selling</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>Support</h5>
            <ul>
              <li><Link to="/orders">Track Order</Link></li>
              <li><Link to="/wishlist">Wishlist</Link></li>
              <li><Link to="/profile">Account</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Store. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
